export const ADHD = 'adhd';
export const ANXIETY = 'anxiety';
export const DEPRESSION = 'depression';
export const BIPOLAR = 'bipolar';
export type ServiceLine =
  | typeof ADHD
  | typeof ANXIETY
  | typeof DEPRESSION
  | typeof BIPOLAR;
